import { Injectable } from "@angular/core";
import { collection, documentId, Firestore, getDocs, limit, orderBy, query } from "@angular/fire/firestore";
import { WellnessAggregate } from "../models/wellness.agg";
import { UserService } from "./user.service";

@Injectable({
    providedIn: 'root'
})
export class AggregatesService {
    constructor(
        private fs: Firestore,
        private userService: UserService,

    ) { }

    async fetchLast30WellnessDays() {
        const dailyColl = collection(
            this.fs,
            "v0",
            "data",
            "user",
            this.userService.user.id,
            "wellness",
            "well-agg",
            "well-agg-daily"
        );

        const q = query(dailyColl, orderBy('day', "desc"), limit(15));
        const snap = await getDocs(q);

        const rows: WellnessAggregate[] = [];
        snap.forEach((doc) => {
            const data = doc.data() as Omit<WellnessAggregate, "date">;
            rows.push({ ...data });
        });

        return rows;
    }
}